import { getConfig } from '../config/configuration';
import type { HpDispatchFunction, HpAction } from './actionTypes';
import { fetchResolver } from './fetchResolver';
import { ErrorMap } from 'interfaces/errorTypes';
import { SearchInputs } from 'components/feature/search/searchUtils';
import { getSearchValidation } from 'validation/searchValidation';

export function resetCustomerSearchAction(): HpAction<void> {
  return {
    type: 'CUSTOMER_SEARCH_RESET'
  };
}

export function customerSearchAction(search: SearchInputs) {
  return (dispatch: HpDispatchFunction<ErrorMap | { [key: string]: string }>): Promise<void> | undefined => {
    dispatch({ type: 'CUSTOMER_SEARCH_RESET' });
    const validation = getSearchValidation(search);

    if (Object.keys(validation.errors).length > 0) {
      dispatch({
        type: 'SEARCH_VALIDATION_ERROR',
        payload: validation.errors
      });
    } else {
      dispatch({ type: 'SEARCH_VALIDATION_SUCCESS' });

      const { websiteEndpoint } = getConfig();
      const url = `${websiteEndpoint}/api/customer-search`;
      const data = JSON.stringify(search);

      return fetchResolver<any>({
        options: { url, method: 'POST', description: `Search policies`, data },
        dispatch,
        successAction: () => {
          dispatch({ type: 'CUSTOMER_SEARCH_SUCCESS' });
        },
        failedAction: (err) => {
          dispatch({ type: 'CUSTOMER_SEARCH_ERROR', payload: err.message });
        }
      });
    }
  };
}
